class CountdownClock extends HTMLElement {
  constructor() {
    super();

    this.countDownNumberDays = this.querySelector('[data-days-number]');
    this.countDownTextDays = this.querySelector('[data-days-text]');
    this.countDownNumberHours = this.querySelector('[data-hours-number]');
    this.countDownTextHours = this.querySelector('[data-hours-text]');
    this.countDownNumberMins = this.querySelector('[data-mins-number]');
    this.countDownTextMins = this.querySelector('[data-mins-text]');
    this.countDownNumberSecs = this.querySelector('[data-secs-number]');
    this.countDownTextSecs = this.querySelector('[data-secs-text]');

    this.countDownMessageOriginal = this.dataset.message;

    const deadlineHour = parseInt(this.dataset.deadlineHour);
    const deadlineDay = parseInt(this.dataset.deadlineDay);
    const deadlineMonth = parseInt(this.dataset.deadlineMonth);
    const deadlineYear = parseInt(this.dataset.deadlineYear);
    const deadlineMinute = 0;

    this.deadlineDate = new Date();
    this.deadlineDate.setFullYear(deadlineYear);
    this.deadlineDate.setMonth(deadlineMonth - 1);
    this.deadlineDate.setDate(deadlineDay);
    this.deadlineDate.setHours(deadlineHour, deadlineMinute);

    this.dateNow = new Date();
    this.dateStringNow = this.dateNow.toDateString();

    console.log('this date now');
    console.log(this.dateNow);
    console.log('this date string now');
    console.log(this.dateStringNow);

    let beforeCutoff = this.dateNow < this.deadlineDate;

    if (beforeCutoff) {
      this.clockTimer = setInterval(this.updateClock.bind(this), 1000);
      console.log('this.clockTimer');
      console.log(this.clockTimer);
      this.setAttribute('role', 'timer');
      this.classList.remove('hidden');
    } else {
      this.classList.add('hidden');
    }
  }
  timeRemaining(deadline) {
    let dateNow = new Date();
    let t = deadline - dateNow.valueOf();
    let days = Math.floor(t / (1000 * 60 * 60 * 24));
    let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((t % (1000 * 60)) / 1000);
    return {
      t: t,
      d: days,
      h: hours,
      m: minutes,
      s: seconds,
    };
  }
  buildCountdownString(time) {
    const spanOpenTag = `<span class='countdown-number'>`;
    const spanCloseTag = `</span>`;
    let countdownMessage = '';
    countdownMessage = `<span class='countdown-number'>
    ${time.d} ${time.d == 1 ? 'day' : 'days'},
    ${time.h} ${time.h == 1 ? 'hour' : 'hours'},
    ${time.m} ${time.m == 1 ? 'minute' : 'minutes'},
    ${time.s} ${time.s == 1 ? 'second' : 'seconds'}
    </span>`;

    return countdownMessage;
  }

  formatNumber(timeNumber) {
    if (timeNumber < 10) {
      timeNumber = `0${timeNumber}`;
    }
    return timeNumber;
  }

  buildCountdownNumberDays(time) {
    let countdownNumberDays = '';
    time.d = this.formatNumber(time.d);
    countdownNumberDays = `${time.d}`;
    return time.d;
  }

  buildCountdownStringDays(time) {
    let countdownMessageDays = '';
    countdownMessageDays = `${time.d == 1 ? 'day' : 'days'}`;
    return countdownMessageDays;
  }
  
  buildCountdownNumberHours(time) {
    time.h = this.formatNumber(time.h);
    return time.h;
  }

  buildCountdownStringHours(time) {
    let countdownMessageHours = '';
    countdownMessageHours = `${time.h == 1 ? 'hour' : 'hours'}`;
    return countdownMessageHours;
  }

  buildCountdownNumberMins(time) {
    time.m = this.formatNumber(time.m);
    return time.m;
  }

  buildCountdownStringMins(time) {
    let countdownMessageMins = '';
    countdownMessageMins = `${time.m == 1 ? 'minute' : 'minutes'}`;
    return countdownMessageMins;
  }

  buildCountdownNumberSecs(time) {
    time.s = this.formatNumber(time.s);
    return time.s;
  }

  buildCountdownStringSecs(time) {
    let countdownMessageSecs = '';
    countdownMessageSecs = `${time.s == 1 ? 'second' : 'seconds'}`;
    return countdownMessageSecs;
  }

  updateClock() {
    let time = this.timeRemaining(this.deadlineDate);

    if (time.t < 0) {
      clearInterval(this.clockTimer);
      this.classList.add('hidden');
    }

    //Days
    let numbers_days = this.buildCountdownNumberDays(time);
    this.countDownNumberDays.innerHTML = `${numbers_days}`;
    let text_days = this.buildCountdownStringDays(time);
    this.countDownTextDays.innerHTML = `${text_days}`;

    //Hours
    let numbers_hours = this.buildCountdownNumberHours(time);
    this.countDownNumberHours.innerHTML = `${numbers_hours}`;
    let text_hours = this.buildCountdownStringHours(time);
    this.countDownTextHours.innerHTML = `${text_hours}`;

    //Minutes
    let numbers_mins = this.buildCountdownNumberMins(time);
    this.countDownNumberMins.innerHTML = `${numbers_mins}`;
    let text_mins = this.buildCountdownStringMins(time);
    this.countDownTextMins.innerHTML = `${text_mins}`;

    //Seconds
    let numbers_secs = this.buildCountdownNumberSecs(time);
    this.countDownNumberSecs.innerHTML = `${numbers_secs}`;
    let text_secs = this.buildCountdownStringSecs(time);
    this.countDownTextSecs.innerHTML = `${text_secs}`;

  }
}
customElements.define('countdown-clock', CountdownClock);
